export function CheckNullParams(params) {
  for (const key in params) {
    if (
      params[key] === null ||
      params[key] === "" ||
      params[key] === undefined
    ) {
      delete params[key];
    }
  }

  return params;
}

